Vue.component('sources-pie-chart',{
    props: ['from_date', 'to_date', 'isLoading', 'split_color'],
    template:`<slot></slot>`,

    data() {
        return {
            chart: null,
            chart2: null,
            collapsed: -1,
            activeLegends: [],
            hoveredId: -1,
            labels: {
                'google': 'Google',
                'trip_advisor': 'TripAdvisor',
                'booking_com': 'Booking',
                'hotels_com': 'Hotels.com',
                'expedia': 'Expedia',
                'zoover': 'Zoover',
                'ctrip': 'Trip.com',
                'agoda': 'Agoda',
                'orbitz': 'Orbitz',
                'facebook_pages': 'Facebook',
                'ebookers': 'Ebookers',
                'cheaptickets': 'CheapTickets',
                'holiday_check': 'HolidayCheck.de',
                'hrs': 'HRS',
                'venere': 'Venere',
                'hotels_de': 'Hotel.de',
                'travelocity': 'Travelocity',
                'wotif': 'Wotif',
                'goibibo': 'goibibo.com',
                'priceline': 'Priceline'
            }
        }
    },
    mounted() {

        let area = this.$refs.sources_chart;
        let area2 = this.$refs.sources_chart2;
        var instance = this;

        var draw = Chart.controllers.doughnut.prototype.draw;

        var ctx = area2.getContext("2d")

        var gradient = ctx.createLinearGradient(0, 0, 269, 270)
        gradient.addColorStop(0, 'rgba(0, 0, 0, 0.75)')
        gradient.addColorStop(0.5, 'rgba(0, 0, 0, 0)')

        var gradient2 = ctx.createLinearGradient(0, 0, 269, 270)
        gradient2.addColorStop(1, 'rgba(0, 0, 0, 0.75)')
        gradient2.addColorStop(0.5, 'rgba(0, 0, 0, 0)')
        // gradient.addColorStop(0.1, 'rgba(0, 0, 0, 0.75)')
        // gradient.addColorStop(1, 'rgba(0, 0, 0, 0)')

        var gradient3 = ctx.createLinearGradient(150, -100, 0, 250)
        gradient3.addColorStop(1, 'rgba(0, 0, 0, 0.75)')
        gradient3.addColorStop(0.5, 'rgba(1, 0, 0, 0)')

        var gradient4 = ctx.createLinearGradient(40, -30, 49, 250)
        gradient4.addColorStop(1, 'rgba(0, 0, 0, 0.75)')
        gradient4.addColorStop(0.5, 'rgba(1, 0, 0, 0)')
        
        var tmp = new Chart(area, {
                type: 'doughnut',
                data: {
                    labels: [],
                    datasets: [{
                        label: 'Average Rating',
                        data: [],
                        backgroundColor:["#00afef", "#8b72f5","#0153b9", '#44d4d2']
                    }],
                },
                options: {
                    elements: {
                        arc: {
                            borderWidth: 2,
                            borderColor: this.split_color
                        }
                    },
                    legend: {
                        display: false,
                    },
                    responsive: false,
                    cutoutPercentage: 40,
                    tooltips: {
                        callbacks: {
                          label: function(tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                            var total = meta.total;
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = parseFloat((currentValue/total*100).toFixed(1));
                            return currentValue + ' (' + percentage + '%)';
                          },
                          title: function(tooltipItem, data) {
                            return instance.labels[data.labels[tooltipItem[0].index]];
                          }
                        }
                    }
                }
        });

        var tmp2 = new Chart(area2, {
                type: 'doughnut',
                data: {
                    labels: [],
                    datasets: [{
                        label: 'Average Rating',
                        data: [],
                        backgroundColor: [gradient, gradient2, gradient3, gradient4],
                        borderColor: '#ffffff'
                    }],
                },
                options: {
                    elements: {
                        arc: {
                            borderWidth: 0,
                            borderColor: this.split_color
                        }
                    },
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        enabled: false,

                        custom: function(tooltipModel) {

                            if (tooltipModel.title) {
                                instance.hoveredId = tooltipModel.dataPoints[0].index;
                            } else {
                                instance.hoveredId = -1
                            }
                            
                        }
                    },
                    hover: {
                        // mode: null
                    },
                    responsive: false,
                    cutoutPercentage: 40
                }
        });

        this.chart = tmp;
        this.chart2 = tmp2;
        
        var currentInstance = this;
        
        area.click( 
            function(evt){

                var activePoints = tmp.getElementsAtEvent(evt);
                var firstPoint = activePoints[0];
                var label = tmp.data.labels[firstPoint._index];
                currentInstance.filterReviews(label);
                //var value = tmp.data.datasets[firstPoint._datasetIndex].data[firstPoint._index];
                //alert(label + ": " + value);

            }
        );

        this.$eventHub.$on('updatePieChart', (sources) => this.updateChart(sources));
    },

    methods: {
        updateChart(sources) {

            this.chart.data.labels = Object.keys(sources);
            this.chart.data.datasets[0].data = Object.keys(sources).map(source => sources[source].count);

            this.chart2.data.labels = Object.keys(sources);
            this.chart2.data.datasets[0].data = Object.keys(sources).map(source => sources[source].count);

            var averageRatings = Object.keys(sources).map(source => sources[source].average);
            var numReviews = Object.keys(sources).map(source => sources[source].count);

            this.activeLegends = [];

            var totalSum = 0 ;

            for (var source_index in sources) {
                totalSum += sources[source_index].count
            }


            for (var i = 0; i < this.chart.data.datasets[0].data.length; i++) {

                var percentage = parseFloat(100 * this.chart.data.datasets[0].data[i] / totalSum).toFixed(1) + " %";
                var averageRating = averageRatings[i];
                var label = this.chart.data.labels[i];
                var numberOfReviews = this.chart.data.datasets[0].data[i];
                var legendColor = this.chart.data.datasets[0].backgroundColor[i];
                this.activeLegends.push([label, numberOfReviews, legendColor, percentage, averageRating]);

            }

            this.sources = sources;

            this.chart.update();
            this.chart2.update();

        },
        
        filterReviews(label) {

            let params = {
                fromDate: this.from_date,
                toDate: this.to_date,
                source: [label]
            }

            $('.spark-settings-tabs a[href$="#reviews"]').tab('show');
            this.$eventHub.$emit('applyFilters', params);
        },
        toggleCollapsed(idx) {
            
            if (this.collapsed == idx) {
                this.collapsed = -1
            } else {
                this.collapsed = idx
            }

        },
        collapseTooltip(event, idx) {
            
            event.preventDefault()

            this.toggleCollapsed(idx)

        },

        handleClickEvent(event) {
            let activePoints = this.chart2.getElementsAtEvent(event)
            
            if (! activePoints || activePoints.length == 0) {
                return
            }

            let index = activePoints[0]._index
            this.toggleCollapsed(index)
        }
    }
})